import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import AddIconImage from '../../shared/svg/plus.svg';
import CompletedIconImage from '../../shared/svg/check.svg';

import ImageCard from '../../components/ImageCard';

import './index.scss';
import ListPage from '../../layouts/ListPage';

function Dashboard() {
  const retailer = useSelector(state => state.retailer);

  const profileCompletionChecks = [
    {
      title: 'Set up your brand',
      completed: !!retailer?.website_url,
      uri: '/profile'
    },
    {
      title: 'Select recipes',
      completed: true,
      uri: '/recipes'
    },
    {
      title: 'Add Beef Cuts',
      completed: true,
      uri: '/beef-cuts'
    },
    {
      title: 'Add Cooking Methods',
      completed: true,
      uri: '/cooking-methods'
    },
    {
      title: 'Add Articles',
      completed: true,
      uri: '/articles'
    },
  ];

  return (
    <ListPage
      title={'Welcome to your beef information gateway'}
      description={'View and manage recipes, beef cuts, cooking methods, and more.'}
      breadcrumbsLinks={[
        {
          url: '/',
          content: 'Content Library',
        },
      ]}
    >
      <Box className="check-icon" sx={{ flexGrow: 1, my: 3 }}>
        <Grid container spacing={2}>
          {profileCompletionChecks.map((check) => (
            <Grid key={check.title} item xs={6} md={4} lg={3} xl={2}>
              <Link to={check.uri}>
                <ImageCard
                  item={{
                    title: check.title,
                    url: check.completed ? CompletedIconImage : AddIconImage
                  }}
                  icon={true}
                  imageBackground='#fff'
                />
              </Link>
            </Grid>
          ))}
        </Grid>
      </Box>
    </ListPage>
  )
}

export default Dashboard;